module.exports = __webpack_public_path__ + "img/Collect.4770b8c7.svg";